import PageTitleBar from '@components/layout/page-title-bar/page-title-bar';
import RestaurantCard, {
  RestaurantCardGrid,
} from '@components/restaurants/restaurant-card/restaurant-card';
import { v2_fetchBranchesFallback, v2_useBranches } from '@crocodille/common';
import { getDayOfWeek } from '@crocodille/util';
import { AppPage } from '@framework/page';
import { getAboutLayout } from '@layouts/about-layout/about-layout';
import { getApp } from '@utils/app';
import { getServerSideTranslationProps } from '@utils/i18n';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'react-i18next';

export interface RestaurantsPageProps {
  readonly fallback: Record<string, unknown>;
}

const RestaurantsPage: AppPage<RestaurantsPageProps> = () => {
  const { t } = useTranslation('restaurants');
  const { data: branches } = v2_useBranches();
  const today = getDayOfWeek(new Date());

  return (
    <>
      <PageTitleBar title={t('page_title')} />
      <RestaurantCardGrid>
        {branches?.map((branch) => (
          <RestaurantCard
            key={branch.code}
            name={branch.name}
            imageSrc={branch.imagePath}
            address={branch.address}
            openFrom={branch.openingHours[today]?.openFrom}
            openTo={branch.openingHours[today]?.openTo}
            deliveryFrom={branch.openingHours[today]?.deliveryFrom}
            deliveryTo={branch.openingHours[today]?.deliveryTo}
            code={branch.code}
          />
        ))}
      </RestaurantCardGrid>
    </>
  );
};

RestaurantsPage.getLayout = (page, pageProps) => {
  return getAboutLayout(page, pageProps.fallback);
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const app = getApp(ctx);

  const [translationProps, branchesFallback] = await Promise.all([
    getServerSideTranslationProps(app, ['common', 'restaurants']),
    v2_fetchBranchesFallback(app),
  ]);

  return {
    props: {
      ...translationProps,
      fallback: { ...branchesFallback },
    },
  };
};

export default RestaurantsPage;
